import gql from 'graphql-tag';

export const FUND_TYPE = gql`
    query MutualFundType($ticker: String!) {
        mutualFund(ticker: $ticker) {
            advisorClass
            assetClassName
            bond
            iClass
            moneyMarket
            name: shortName
            shortName
            rClass
            taxFree
            ticker
            trpFund
            trpCode
            openToNewInvestors
            openToSubsequentInvestments
        }
    }
`;
export const ETF_FUND_TYPE = gql`
    query ETFFundType($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            name
            ticker
            trpCode
            transparencyTypeName
            assetClassName
            distribution {
                distributionFrequency
            }
        }
    }
`;
